import CategoryPage from './CategoryPage';

const SinalizacaoPage = () => <CategoryPage category="sinalizacao" />;

export default SinalizacaoPage;
